import React, { useState, useEffect } from 'react';
import { BEAM_API } from '../../apiConfig';

import axios from 'axios';
import { Line } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// images
// import Background from '../../images/BeamDeflaction-FirstSection-Background.jpg';

import backgroundJPG from '../../images/BeamDeflaction-FirstSection-Background.jpg';   // Replace with your actual image path
import backgroundWebP from '../../images/BeamDeflaction-FirstSection-Background.webp'; // WebP version of the image

import CrossSectionImg from '../../images/beam deflection image/cross section.png';
import YoungsModulusImg from '../../images/beam deflection image/youngs modulus.jpg';
import FixedSupportSymbolsImg from '../../images/beam deflection image/fixed support symbol.png';
import PinnedSupportSymbolsImg from '../../images/beam deflection image/BeamDeflaction-Blackbox-Pined-support.png';
import RollerSupportSymbolsImg from '../../images/beam deflection image/BeamDeflaction-Blackbox-roller-support.png';
import PointLoadSymbolsImg from '../../images/beam deflection image/point load symbol.png';
import PointLoadSymbolsForReactionsImg from '../../images/beam deflection image/point load symbol for reactions.png';
import DistributedLoadSymbolsImg from '../../images/beam deflection image/distributed support symbol.png';
import Non_DistributedLoadSymbolsImg1 from '../../images/beam deflection image/non distributed support symbol 01.png';
import Non_DistributedLoadSymbolsImg2 from '../../images/beam deflection image/non distributed support symbol 02.png';
// CSS
import '../../Css/BeamProperties.css'
import '../../Css/BeamDeflection.css'
import '../../Css/NumberLine.css'
import '../../Css/AboutUS.css'
import '../../Css/Navbar.css'
import '../../Css/Padeye.css'
import './BeamDeflectionPro.css'

// icons
import { MdDelete } from "react-icons/md";
import { GrLinkTop } from "react-icons/gr";
// import VideoPlayerSection from './VideoPlayer/VideoPlayerSection';

import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

export default function BeamDeflection() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const [selectedOption, setSelectedOption] = useState("option1");
  const handleOptionChange = (option) => {
    setSelectedOption(option)
  }

  const [isActive3, setIsActive3] = useState(false);
  const [activeFaq, setActiveFaq] = useState(0);

  const toggleClass3 = () => {

    setIsActive3(true);
  };

  const [expanded, setExpanded] = useState(false);
  const [Sectionthird, setSectionthird] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100 && !expanded) {
        setExpanded(true);
      }
      if (window.scrollY > 350 && !Sectionthird) {
        setSectionthird(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [expanded, Sectionthird]);

  const [showfirstDiv, setShowFirstDiv] = useState(false);
  const [showSecondDiv, setShowSecondDiv] = useState(false);
  const [showThirdDiv, setShowThirdDiv] = useState(false);

  // Toggle with delay function
  const handleToggleWithDelay = () => {
    if (!showfirstDiv && !showSecondDiv && !showThirdDiv) {
      // Open in sequence: First, Second, then Third
      setShowFirstDiv(true);
      setTimeout(() => {
        setShowSecondDiv(true);
        setTimeout(() => {
          setShowThirdDiv(true);
        }, 2000);
      }, 2000);
    }
  };
  const handleCombinedClick = () => {
    handleToggleWithDelay();
    toggleClass3();
    sendData()
  };

  const DropDowmOneMain = `
    rightBeamDeflactionDropDown
    reactiongraph
      
    ${!showfirstDiv && !showSecondDiv && !showThirdDiv ? 'hiddenBeamDeflection' : 'showBeamDeflection'}

      ${showfirstDiv ? 'ScrollTransactionOne' : ''}
  `;
  const DropDowmOnerightMain = `
    rightBeamDeflactionDropDown rightsideBeamDeflactionDropDown
    
    ${!showfirstDiv && !showSecondDiv && !showThirdDiv ? 'hiddenBeamDeflection' : 'showBeamDeflection'}

    ${showfirstDiv ? 'ScrollTransactionOne' : ''}
  `;
  const DropDowmTwoMain = `
   ScrollTransactionTwoBeamDeflactionDropDown
    LoadBendingDeflectionclasses
    ${!showfirstDiv && !showSecondDiv && !showThirdDiv ? 'hiddenBeamDeflection' : 'showBeamDeflection'}

    ${showfirstDiv ? 'ScrollTransactionOne' : ''}
    ${showSecondDiv ? 'ScrollTransactionTwo' : ''}
  `;
  const DropDowmTworightMain = `
    ScrollTransactionTwoBeamDeflactionDropDown rightsideTwoBeamDeflactionDropDown
  LoadBendingDeflectionclasses
    ${!showfirstDiv && !showSecondDiv && !showThirdDiv ? 'hiddenBeamDeflection' : 'showBeamDeflection'}

    ${showfirstDiv ? 'ScrollTransactionOne' : ''}
  ${showSecondDiv ? 'ScrollTransactionTwo' : ''}
  `;
  // const DropDowmthirdMain = `
  //   ScrollTransactionTwoBeamDeflactionDropDown rightsideTwoBeamDeflactionDropDown top405
  // LoadBendingDeflectionclasses
  //   ${!showfirstDiv && !showSecondDiv && !showThirdDiv ? 'hiddenBeamDeflection' : 'showBeamDeflection'}

  //   ${showfirstDiv ? 'ScrollTransactionOne' : ''}
  // ${showSecondDiv ? 'ScrollTransactionTwo' : ''}
  // ${showThirdDiv ? 'ScrollTransactionThree' : ''}
  // `;

  // Deflection function code

  const YoungModulessunits = ['Mpa', 'Pa'];
  const YoungModulessConversionFactors = {
    Mpa: [1, 1e6],
    Pa: [1e-6, 1],
  };
  const [youngModules, setYoungModulessValue] = useState(200000);
  const [YoungModulesselectedUnit, setYoungModulessSelectedUnit] = useState('Mpa');
  const [YoungModulessInMPa, setYoungModulessInMPa] = useState(200000);

  const handleYoungModulesChange = (value) => {
    setYoungModulessValue(value);
    const factor = YoungModulessConversionFactors[YoungModulesselectedUnit][0];
    setYoungModulessInMPa(parseFloat(value) * factor);
  };

  const handleYoungModuleschange = (unit) => {
    let newValue = parseFloat(youngModules);
    if (unit === 'Pa' && YoungModulesselectedUnit === 'Mpa') {
      newValue *= 1e6;
      if (newValue >= 1000) {
        newValue = newValue.toExponential(3);
      }
    } else if (unit === 'Mpa' && YoungModulesselectedUnit === 'Pa') {
      newValue /= 1e6;
    }
    setYoungModulessSelectedUnit(unit);
    setYoungModulessValue(isNaN(newValue) ? 0 : newValue);
  };


  const [area, setArea] = useState(1780);
  const [areaSelectedUnit, setareaSelectedUnit] = useState('mm²');
  const [internalareaValue, setInternalareaValue] = useState(1780); // Always in mm
  const areaUnits = ['mm²', 'm²'];
  const areaMetricConversionFactors = {
    'mm²': [1, 1e-6], // 1 mm² = 1e-6 m²
    'm²': [1e6, 1],   // 1 m² = 1e6 mm²
  };

  const handleareaInputChange = (value) => {
    setArea(value);
    const factor = areaMetricConversionFactors[areaSelectedUnit][0];
    setInternalareaValue(parseFloat(value) * factor);
  };

  const handleareaUnitChange = (unit) => {
    const newMetricValueInMM = parseFloat(area) * areaMetricConversionFactors[areaSelectedUnit][0];
    const convertedValue = newMetricValueInMM / areaMetricConversionFactors[unit][0];
    setareaSelectedUnit(unit);
    setArea(isNaN(convertedValue) ? 0 : convertedValue);
  };

  const [inertia, setInertia] = useState(6660000);
  const [InertiaSelectedUnit, setInertiaSelectedUnit] = useState('mm⁴');
  const [internalInertiaValue, setInternalInertiaValue] = useState(6660000); // Always in mm
  const InertiaUnits = ['mm⁴', 'm⁴'];
  const InertiaMetricConversionFactors = {
    'mm⁴': [1, 1e-12], // 1 mm⁴ = 1e-12 m⁴
    'm⁴': [1e12, 1],   // 1 m⁴ = 1e12 mm⁴
  };

  const handleInertiaInputChange = (value) => {
    setInertia(value);
    const factor = InertiaMetricConversionFactors[InertiaSelectedUnit][0];
    setInternalInertiaValue(parseFloat(value) * factor);
  };

  const handleInertiaUnitChange = (unit) => {
    const newMetricValueInMM = parseFloat(inertia) * InertiaMetricConversionFactors[InertiaSelectedUnit][0];
    const convertedValue = newMetricValueInMM / InertiaMetricConversionFactors[unit][0];
    setInertiaSelectedUnit(unit);
    setInertia(isNaN(convertedValue) ? 0 : convertedValue);
  };

  const [supports, setSupports] = useState([{ type: 'fixed', position: 0 }]);
  const [pointLoads, setPointLoads] = useState([{ position: 0, magnitude: 10000 }]);
  const [pointLoadSelectedUnit, setPointLoadSelectedUnit] = useState('KN'); // Default unit is Newton



  const [distributedLoads, setDistributedLoads] = useState([
    { start_position: 0, end_position: 0, start_magnitude: 0, end_magnitude: 0 },
  ]);
  const [distributedLoadSelectedUnit, setDistributedLoadSelectedUnit] = useState('KN/m'); // Default unit is Newton/meter


  const [reactionData, setReactionData] = useState([]);
  const [deflectionData, setDeflectionData] = useState([]);
  const [shearForceData, setShearForceData] = useState([]);
  const [bendingMomentData, setBendingMomentData] = useState([]);
  const handlePointLoadChange = (index, field, value) => {
    const newPointLoads = [...pointLoads];
    newPointLoads[index][field] = Number(value);
    setPointLoads(newPointLoads);
  };

  const handleDistributedLoadChange = (index, field, value) => {
    const newDistributedLoads = [...distributedLoads];
    newDistributedLoads[index][field] = Number(value);
    setDistributedLoads(newDistributedLoads);
  };

  const handleSupportChange = (index, field, value) => {
    const newSupports = [...supports];
    newSupports[index][field] = value;
    setSupports(newSupports);
  };

  const addSupport = () => {
    setSupports([...supports, { type: 'fixed', position: 0 }]);
  };
  const deleteSupport = (index) => {
    const newSupports = supports.filter((_, i) => i !== index);
    setSupports(newSupports);
  };
  const addPointLoad = () => {
    setPointLoads([...pointLoads, { position: 0, magnitude: 0 }]);
  };
  const deletePointLoad = (index) => {
    const newPointLoads = pointLoads.filter((_, i) => i !== index);
    setPointLoads(newPointLoads);
  };

  const addDistributedLoad = () => {
    setDistributedLoads([...distributedLoads, { start_position: 0, end_position: 0, start_magnitude: 0, end_magnitude: 0 }]);
  };
  const deleteDistributedLoad = (index) => {
    const newDistributedLoads = distributedLoads.filter((_, i) => i !== index);
    setDistributedLoads(newDistributedLoads);
  };

  const [length, setLength] = useState(2000); // Length in selected unit
  const [internalLengthValue, setInternalLengthValue] = useState(0); // Always in mm
  const [lengthSelectedUnit, setLengthSelectedUnit] = useState('mm');
  const LengthUnits = ['mm', 'm'];
  const LengthMetricConversionFactors = {
    mm: [1, 0.001],
    m: [1000, 1],
  };

  // Handle input change for length
  const handleLengthInputChange = (value) => {
    setLength(value);
    const factor = LengthMetricConversionFactors[lengthSelectedUnit][0];
    setInternalLengthValue(parseFloat(value) * factor);
  };

  // Handle unit change for length
  const handleLengthUnitChange = (unit) => {
    const newMetricValueInMM = parseFloat(length) * LengthMetricConversionFactors[lengthSelectedUnit][0];
    const convertedValue = newMetricValueInMM / LengthMetricConversionFactors[unit][0];
    setLengthSelectedUnit(unit);
    setLength(isNaN(convertedValue) ? 0 : convertedValue);
  };

  // Dynamically calculate step size
  const calculateStepSize = () => {
    const desiredLabels = 5; // Target number of labels
    const range = length; // Use length in the selected unit for display
    if (range < 10) {
      return 0.5; // Show points for small ranges
    }
    return Math.ceil(range / desiredLabels / 5) * 5; // Round to nearest 5 for clean steps
  };

  const step = calculateStepSize(); // Calculate step size
  const values = Array.from({ length: Math.ceil(length / step) + 1 }, (_, i) => i * step);

  // Get the image source based on the support type
  // Function to dynamically get the support image
  const getSupportImage = (type) => {
    switch (type) {
      case "fixed":
        return FixedSupportSymbolsImg; // Replace with your image path
      case "roller":
        return RollerSupportSymbolsImg; // Replace with your image path
      case "pinned":
        return PinnedSupportSymbolsImg; // Replace with your image path
      default:
        return "";
    }
  };


  // Send data to the backend
  const sendData = () => {
    axios
      .post(
        `${BEAM_API}/beam`, // Uses central API BASE URL
        {
          length: Number(length), // Use internalLengthValue in mm for the backend
          youngmodules: Number(youngModules),
          area: Number(area),
          inertia: Number(inertia),
          supports: supports.map((s) => ({ type: s.type, position: Number(s.position) })),
          point_loads: pointLoads,
          distributed_loads: distributedLoads,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        setReactionData(response.data.reactions);
        setDeflectionData(response.data.deflection_data);
        setShearForceData(response.data.shear_force_data);
        setBendingMomentData(response.data.bending_moment_data);
        console.log('Response from Flask:', response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };


  const deflectionChartData = {
    labels: deflectionData.map(item => item.position),
    datasets: [
      {
        fill: true,
        borderColor: '#a855f7',
        backgroundColor: 'rgba(168, 85, 247, 0.1)',
        pointBackgroundColor: '#a855f7',
        pointBordercolor: 'var(--site-ink)',
        data: deflectionData.map(item => item.deflection),
        pointRadius: 0,
      },
    ],
  };

  const shearForceChartData = {
    labels: shearForceData.map(item => item.position),
    datasets: [
      {
        fill: true,
        borderColor: '#10b981',
        backgroundColor: 'rgba(16, 185, 129, 0.1)',
        pointBackgroundColor: '#10b981',
        pointBordercolor: 'var(--site-ink)',
        pointRadius: 0,
        data: shearForceData.map(item => item.shear_force),
      },
    ],
  };

  const bendingMomentChartData = {
    labels: bendingMomentData.map(item => item.position),
    datasets: [
      {
        fill: true,
        borderColor: '#3b82f6',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        pointBackgroundColor: '#3b82f6',
        pointBordercolor: 'var(--site-ink)',
        pointRadius: 0,
        data: bendingMomentData.map(item => item.bending_moment),
      },
    ],
  };

  // const beamLength = 1000; // Example beam length in mm, replace with your actual beam length

  const shearForceChartDataoptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Length',
        },
        ticks: {
          maxTicksLimit: 8,

        },
      },
      y: {
        title: {
          display: true,
          text: 'Shear Force ',
        },
        ticks: {
          maxTicksLimit: 5,
          callback: function (value) {
            // Format ticks for the y-axis
            return value >= 1_000_000
              ? `${value / 1_000_000}M`
              : value >= 1_000
                ? `${value / 1_000}k`
                : value <= -1_000_000
                  ? `${value / 1_000_000}M`
                  : value <= -1_000
                    ? `${value / 1_000}k`
                    : value;
          },
        },
      },
    },
  };

  const bendingMomentChartDataoptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Length',
        },
        ticks: {
          maxTicksLimit: 8,
        },
      },
      y: {
        title: {
          display: true,
          text: 'Bending Moment',
        },
        ticks: {
          maxTicksLimit: 5,
          callback: function (value) {
            // Format ticks for the y-axis
            return value >= 1_000_000
              ? `${value / 1_000_000}M`
              : value >= 1_000
                ? `${value / 1_000}k`
                : value <= -1_000_000
                  ? `${value / 1_000_000}M`
                  : value <= -1_000
                    ? `${value / 1_000}k`
                    : value;
          },
        },
      },
    },
  };
  const deflectionChartDataoptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Length',
        },
        ticks: {
          maxTicksLimit: 8,
        },
        max: length, // Ensure the last tick aligns with the beam length
      },
      y: {
        title: {
          display: true,
          text: 'Deflection '
        },
        ticks: {
          maxTicksLimit: 5,
          callback: function (value) {
            // Format ticks for the y-axis
            return value >= 1_000_000
              ? `${value / 1_000_000}M`
              : value >= 1_000
                ? `${value / 1_000}k`
                : value <= -1_000_000
                  ? `${value / 1_000_000}M`
                  : value <= -1_000
                    ? `${value / 1_000}k`
                    : value;
          },
        },
      },
    },
  };


  return (
    <div className="beam-defl-pro-page body">
      <Helmet>
        <title>Beam Deflection Calculator – OOK | Structural Analysis Tool</title>
        <meta
          name="description"
          content="Calculate beam deflection, slope, and shear with precision. Ideal for engineers requiring reliable stress analysis for complex loading conditions across various materials and beam profiles. Professional-grade structural engineering results delivered in seconds."
        />
        <link rel="canonical" href="https://www.ook-calculator.com/BeamDeflection" />
      </Helmet>

      {/* ══ HERO ══ */}
      <section className="hero">
        <br />
        <br />
        <div className="breadcrumb">
          <a href="/">Calculators</a> <span>/</span> <strong>Beam Properties</strong>
        </div>
        <div className="hero-badge">FREE ENGINEERING TOOL — LIVE RESULTS</div>
        <h1>Beam <em>Deflection</em><br />Calculator</h1>
        <p className="hero-desc">
          Compute maximum deflection, slope, support reactions, and bending moment for simply supported, cantilever, and fixed–fixed beams. Covers point loads, uniform distributed loads (UDL), and applied moments — with a live deflection diagram.
        </p>
      </section>
      {/* ══ CALCULATOR ══ */}
      <div className="main-wrap" id="calculator">
        {/* LEFT: INPUTS */}
        <div>
          <div className="card">
            <div className="card-header">
              <div className="card-header-dot"></div>
              <span className="card-title">Beam Configuration</span>
            </div>
            <div className="card-body">
              <div className="field">
                <label>Input Category</label>
                <div className="tab-group" id="beam-tabs" style={{ flexWrap: 'wrap' }}>
                  <button className={`tab-btn ${selectedOption === 'option1' ? 'active' : ''}`} onClick={() => handleOptionChange('option1')}>Length</button>
                  <button className={`tab-btn ${selectedOption === 'option2' ? 'active' : ''}`} onClick={() => handleOptionChange('option2')}>Young's Modulus</button>
                  <button className={`tab-btn ${selectedOption === 'option3' ? 'active' : ''}`} onClick={() => handleOptionChange('option3')}>Cross Section</button>
                  <button className={`tab-btn ${selectedOption === 'option4' ? 'active' : ''}`} onClick={() => handleOptionChange('option4')}>Support</button>
                  <button className={`tab-btn ${selectedOption === 'option5' ? 'active' : ''}`} onClick={() => handleOptionChange('option5')}>Load</button>
                </div>
              </div>

              <div className="schematic-wrap" style={{ position: 'relative', overflow: 'visible', padding: '0 30px' }}>
                {/* The visualizer block from CenterofDeflectionCalculator */}
                {selectedOption === 'option1' && (
                  <div className="number-line-container" style={{ margin: '40px 0' }}>
                    <div className="line" />
                    <div className="numbers">
                      {values && values.map((value, index) => (
                        <span key={index} className="number" style={{ left: `${(value / length) * 100}%` }}>
                          {value.toLocaleString()}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                {selectedOption === 'option2' && <img src={YoungsModulusImg} alt="Young's Modulus" className="img-fluid" style={{ maxHeight: '150px', objectFit: 'contain', margin: '0 auto', display: 'block' }} />}
                {selectedOption === 'option3' && <img src={CrossSectionImg} alt="Cross Section" className="img-fluid custom-img" style={{ maxHeight: '150px', objectFit: 'contain', margin: '0 auto', display: 'block' }} />}
                {selectedOption === 'option4' && (
                  <div className="number-line-container" style={{ margin: '40px 0' }}>
                    <div className="line">
                      {supports.map((support, index) => (
                        <img
                          key={index}
                          src={getSupportImage(support.type)}
                          alt={support.type}
                          className={`support-image ${support.type}-support`}
                          style={{
                            left: `${Math.min((support.position / length) * 100, 100)}%`,
                            width: 'auto',
                            height: support.type === 'fixed' ? '44px' : '15px',
                            transform: support.type === 'roller' ? 'translate(-50%, 15%)' : 'translate(-50%, 0%)',
                            position: 'absolute',
                            top: support.type === 'fixed' ? '-22px' :
                              (support.type === 'pinned' || support.type === 'roller') ? '0px' : '-22px'
                          }}
                        />
                      ))}
                    </div>
                    <div className="numbers">
                      {values && values.map((value, index) => (
                        <span key={index} className="number" style={{ left: `${(value / length) * 100}%` }}>
                          {value.toLocaleString()}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                {selectedOption === 'option5' && (
                  <div className="number-line-container load" style={{ margin: '60px 0 20px 0' }}>
                    <div className="line">
                      {distributedLoads && distributedLoads.map((load, index) => (
                        <div
                          key={index}
                          className="distributed-load-container"
                          style={{
                            left: `${(load.start_position / length) * 100}%`,
                            width: `${((load.end_position - load.start_position) / length) * 100}%`,
                            position: 'absolute',
                            top: '-15px',
                            height: '30px'
                          }}
                        >
                          {((load.start_magnitude > load.end_magnitude && load.end_position > 0) || (load.end_magnitude < load.start_magnitude && load.start_position > 0)) && (
                            <>
                              <div className="distributed-load-magnitude" style={{ position: 'absolute', top: '-20px', width: '100%', display: 'flex', justifyContent: 'space-between', fontSize: '10px' }}>
                                <div>{load.start_magnitude}</div>
                                <div>{load.end_magnitude}</div>
                              </div>
                              <img src={Non_DistributedLoadSymbolsImg2} alt="Distributed Load" className="distributed-load-image" style={{ width: '100%', height: '100%' }} />
                            </>
                          )}
                          {((load.end_magnitude > load.start_magnitude && load.end_position > 0) || (load.start_magnitude < load.end_magnitude && load.start_position > 0)) && (
                            <>
                              <div className="distributed-load-magnitude" style={{ position: 'absolute', top: '-20px', width: '100%', display: 'flex', justifyContent: 'space-between', fontSize: '10px' }}>
                                <div>{load.start_magnitude}</div>
                                <div>{load.end_magnitude}</div>
                              </div>
                              <img src={Non_DistributedLoadSymbolsImg1} alt="Distributed Load" className="distributed-load-image" style={{ width: '100%', height: '100%' }} />
                            </>
                          )}
                          {/* {((load.start_magnitude !== 0 || load.end_magnitude !== 0 || load.start_position !== 0 || load.end_position !== 0) &&
                            ((load.end_magnitude === load.start_magnitude) || (load.end_position > 0 && load.start_position > 0))) && (
                              <>
                                <div className="distributed-load-magnitude" style={{ position: 'absolute', top: '-20px', width: '100%', display: 'flex', justifyContent: 'space-between', fontSize: '10px' }}>
                                  <div>{load.start_magnitude}</div>
                                  <div>{load.end_magnitude}</div>
                                </div>
                                <img src={DistributedLoadSymbolsImg} alt="Distributed Load" className="distributed-load-image" style={{ width: '100%', height: '100%' }} />
                              </>
                            )} */}
                        </div>
                      ))}
                    </div>

                    {pointLoads && pointLoads.map((pointLoad, index) => (
                      <div
                        key={index}
                        className="point-load-container"
                        style={{
                          left: `${(pointLoad.position / length) * 100}%`,
                          position: 'absolute',
                          // top: '-180%',
                          transform: 'translate(-50%, -100%)',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center'
                        }}
                      >
                        {(pointLoad.position > 0 || pointLoad.magnitude > 0) && (
                          <>
                            <div className="point-load-magnitude" style={{ fontSize: '10px' }}>{pointLoad.magnitude}</div>
                            <img src={PointLoadSymbolsImg} alt="PL" className="point-load-image" style={{ width: '15px' }} />
                          </>
                        )}
                      </div>
                    ))}
                    <div className="numbers">
                      {values && values.map((value, index) => (
                        <span key={index} className="number" style={{ left: `${(value / length) * 100}%` }}>
                          {value.toLocaleString()}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="input-fields-wrap" style={{ marginTop: '24px' }}>
                {selectedOption === 'option1' && (
                  <div className="grid2">
                    <div className="field">
                      <label>Length of Beam (L)</label>
                      <div className="field-row">
                        <input
                          type="number"
                          value={length}
                          onChange={(e) => handleLengthInputChange(e.target.value)}
                        />
                        <select className="field-unit" style={{ background: 'transparent', border: 'none', outline: 'none' }} value={lengthSelectedUnit} onChange={(e) => handleLengthUnitChange(e.target.value)}>
                          {LengthUnits && LengthUnits.map(unit => <option key={unit} value={unit}>{unit}</option>)}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
                {selectedOption === 'option2' && (
                  <div className="grid2">
                    <div className="field">
                      <label>Young's Modulus (E)</label>
                      <div className="field-row">
                        <input
                          type="number"
                          value={youngModules}
                          onChange={(e) => handleYoungModulesChange(e.target.value)}
                        />
                        <select className="field-unit" style={{ background: 'transparent', border: 'none', outline: 'none' }} value={YoungModulesselectedUnit} onChange={(e) => handleYoungModuleschange(e.target.value)}>
                          {YoungModulessunits && YoungModulessunits.map(unit => <option key={unit} value={unit}>{unit}</option>)}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
                {selectedOption === 'option3' && (
                  <div className="grid2">
                    <div className="field">
                      <label>Area (A)</label>
                      <div className="field-row">
                        <input
                          type="number"
                          value={area}
                          onChange={(e) => handleareaInputChange(e.target.value)}
                        />
                        <select className="field-unit" style={{ background: 'transparent', border: 'none', outline: 'none' }} value={areaSelectedUnit} onChange={(e) => handleareaUnitChange(e.target.value)}>
                          {areaUnits && areaUnits.map(unit => <option key={unit} value={unit}>{unit}</option>)}
                        </select>
                      </div>
                    </div>
                    <div className="field">
                      <label>Moment of Inertia (I)</label>
                      <div className="field-row">
                        <input
                          type="number"
                          value={inertia}
                          onChange={(e) => handleInertiaInputChange(e.target.value)}
                        />
                        <select className="field-unit" style={{ background: 'transparent', border: 'none', outline: 'none' }} value={InertiaSelectedUnit} onChange={(e) => handleInertiaUnitChange(e.target.value)}>
                          {InertiaUnits && InertiaUnits.map(unit => <option key={unit} value={unit}>{unit}</option>)}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
                {selectedOption === 'option4' && (
                  <div>
                    {supports && supports.map((support, index) => (
                      <div key={index} style={{ background: 'var(--surface2)', padding: '16px', borderRadius: '8px', marginBottom: '16px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                          <strong style={{ color: 'var(--text1)' }}>Support {index + 1}</strong>
                          <MdDelete onClick={() => deleteSupport(index)} style={{ color: 'var(--red)', cursor: 'pointer', fontSize: '18px' }} />
                        </div>
                        <div className="grid2">
                          <div className="field">
                            <label>Type</label>
                            <div className="field-row" style={{ padding: 0 }}>
                              <select value={support.type} onChange={(e) => handleSupportChange(index, 'type', e.target.value)} style={{ width: '100%', border: 'none', background: 'transparent', padding: '8px', outline: 'none' }}>
                                <option value="pinned">Pinned</option>
                                <option value="roller">Roller</option>
                                <option value="fixed">Fixed</option>
                              </select>
                            </div>
                          </div>
                          <div className="field">
                            <label>Position</label>
                            <div className="field-row">
                              <input type="number" value={support.position} max={length} onChange={(e) => { const value = Math.min(Number(e.target.value), length); handleSupportChange(index, 'position', value); }} aria-label="Position of Support" />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    <button type="button" className="btn-primary" style={{ width: '100%', padding: '10px' }} onClick={addSupport}>+ Add Support</button>
                  </div>
                )}

                {selectedOption === 'option5' && (
                  <div>
                    {/* Point Loads */}
                    {pointLoads && pointLoads.length > 0 && <div className="section-label" style={{ marginBottom: '12px' }}>Point Loads</div>}
                    {pointLoads && pointLoads.map((load, index) => (
                      <div key={index} style={{ background: 'var(--surface2)', padding: '16px', borderRadius: '8px', marginBottom: '16px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                          <strong style={{ color: 'var(--text1)' }}>Point Load {index + 1}</strong>
                          <MdDelete onClick={() => deletePointLoad(index)} style={{ color: 'var(--red)', cursor: 'pointer', fontSize: '18px' }} />
                        </div>
                        <div className="grid2">
                          <div className="field">
                            <label>Position</label>
                            <div className="field-row">
                              <input type="number" value={load.position} min="0" max={length} step="1" onChange={(e) => { const value = Math.min(length, parseFloat(e.target.value) || 0); handlePointLoadChange(index, 'position', value); }} />
                            </div>
                          </div>
                          <div className="field">
                            <label>Magnitude</label>
                            <div className="field-row">
                              <input type="number" value={load.magnitude} onChange={(e) => handlePointLoadChange(index, 'magnitude', e.target.value)} />
                              <select value={pointLoadSelectedUnit} style={{ width: '70px', borderLeft: '1px solid var(--border)', background: 'transparent', padding: '0 8px', outline: 'none' }}>
                                <option value={pointLoadSelectedUnit}>{pointLoadSelectedUnit}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    <button type="button" className="btn-secondary" style={{ width: '100%', padding: '10px', marginBottom: '24px' }} onClick={addPointLoad}>+ Add Point Load</button>

                    {/* Distributed Loads */}
                    {distributedLoads && distributedLoads.length > 0 && <div className="section-label" style={{ marginBottom: '12px' }}>Distributed Loads</div>}
                    {distributedLoads && distributedLoads.map((load, index) => (
                      <div key={index} style={{ background: 'var(--surface2)', padding: '16px', borderRadius: '8px', marginBottom: '16px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                          <strong style={{ color: 'var(--text1)' }}>Distributed Load {index + 1}</strong>
                          <MdDelete onClick={() => deleteDistributedLoad(index)} style={{ color: 'var(--red)', cursor: 'pointer', fontSize: '18px' }} />
                        </div>
                        <div className="grid2">
                          <div className="field">
                            <label>Start Position</label>
                            <div className="field-row">
                              <input type="number" value={load.start_position} max={length} onChange={(e) => { const value = Math.min(length, parseFloat(e.target.value) || 0); handleDistributedLoadChange(index, 'start_position', value); }} />
                            </div>
                          </div>
                          <div className="field">
                            <label>End Position</label>
                            <div className="field-row">
                              <input type="number" value={load.end_position} max={length} onChange={(e) => { const value = Math.min(length, parseFloat(e.target.value) || 0); handleDistributedLoadChange(index, 'end_position', value); }} />
                            </div>
                          </div>
                          <div className="field">
                            <label>Start Magnitude</label>
                            <div className="field-row">
                              <input type="number" value={load.start_magnitude} onChange={(e) => handleDistributedLoadChange(index, 'start_magnitude', e.target.value)} />
                              <span className="field-unit">{distributedLoadSelectedUnit}</span>
                            </div>
                          </div>
                          <div className="field">
                            <label>End Magnitude</label>
                            <div className="field-row">
                              <input type="number" value={load.end_magnitude} onChange={(e) => handleDistributedLoadChange(index, 'end_magnitude', e.target.value)} />
                              <span className="field-unit">{distributedLoadSelectedUnit}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    <button type="button" className="btn-secondary" style={{ width: '100%', padding: '10px' }} onClick={addDistributedLoad}>+ Add Distributed Load</button>
                  </div>
                )}
                <hr style={{ margin: '32px 0', borderColor: 'var(--border)' }} />
                <button type="button" className="btn-primary" style={{ width: '100%', padding: '14px', fontSize: '16px', fontWeight: '600' }} onClick={handleCombinedClick}>
                  Analyze Beam Deflection
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT: RESULTS & GRAPHS */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>

          {/* Reaction Card */}
          <div className="card">
            <div className="card-header" style={{ justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div className="card-header-dot" style={{ background: 'var(--orange)' }}></div>
                <span className="card-title">Reaction</span>
              </div>
            </div>
            <div className="card-body" style={{ minHeight: '150px', position: 'relative', overflow: 'visible', padding: '60px' }}>
              <div className="number-line-container" style={{ margin: '60px 0 40px 0', position: 'relative' }}>
                <div className="line" style={{ position: 'relative' }}>
                  {reactionData && reactionData.length > 0 && reactionData.map((reaction, index) => (
                    <React.Fragment key={index}>
                      <img className="reaction-img" src={PointLoadSymbolsForReactionsImg} alt="reaction" style={{ position: 'absolute', top: '15px', width: '15px', height: '40px', transform: 'translate(-50%, 0%)', left: `${(reaction.position / length) * 100}%` }} />
                      <div className="reaction-indicator" style={{ position: 'absolute', top: '-70px', left: `${(reaction.position / length) * 100}%`, transform: 'translateX(-50%)', whiteSpace: 'nowrap', fontSize: '11px', color: 'var(--text)', background: 'var(--bg2)', padding: '8px 12px', border: '1px solid var(--border)', borderRadius: '8px', zIndex: 10, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)', transition: 'z-index 0s, opacity 0.15s', cursor: 'default' }}
                        onMouseEnter={(e) => { e.currentTarget.style.zIndex = '100'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.18)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.zIndex = '10'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)'; }}
                      >
                        Pos: {reaction.position} mm<br />
                        F: {reaction.force.toFixed(2)} N<br />
                        M: {reaction.momentum.toFixed(2)} N·m
                      </div>
                    </React.Fragment>
                  ))}
                </div>
                <div className="numbers">
                  {values && values.map((value, index) => (
                    <span key={index} className="number" style={{ left: `${(value / length) * 100}%` }}>
                      {value.toLocaleString()}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Shear Force Card */}
          <div className="card">
            <div className="card-header" style={{ justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div className="card-header-dot" style={{ background: '#10b981' }}></div>
                <span className="card-title" style={{ color: '#10b981' }}>Shear Force Diagram</span>
              </div>
            </div>
            <div className="card-body" style={{ paddingBottom: '16px' }}>
              <div className="chart-wrap" style={{ height: '300px' }}>
                <Line data={shearForceChartData} options={{ ...shearForceChartDataoptions, responsive: true, maintainAspectRatio: false }} />
              </div>
            </div>
          </div>

          {/* Bending Moment Card */}
          <div className="card">
            <div className="card-header" style={{ justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div className="card-header-dot" style={{ background: '#3b82f6' }}></div>
                <span className="card-title" style={{ color: '#3b82f6' }}>Bending Moment Diagram</span>
              </div>
            </div>
            <div className="card-body" style={{ paddingBottom: '16px' }}>
              <div className="chart-wrap" style={{ height: '300px' }}>
                <Line data={bendingMomentChartData} options={{ ...bendingMomentChartDataoptions, responsive: true, maintainAspectRatio: false }} />
              </div>
            </div>
          </div>

          {/* Deflection Card */}
          <div className="card">
            <div className="card-header" style={{ justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div className="card-header-dot" style={{ background: '#a855f7' }}></div>
                <span className="card-title" style={{ color: '#a855f7' }}>Deflection Diagram</span>
              </div>
            </div>
            <div className="card-body" style={{ paddingBottom: '16px' }}>
              <div className="chart-wrap" style={{ height: '300px' }}>
                <Line data={deflectionChartData} options={{ ...deflectionChartDataoptions, responsive: true, maintainAspectRatio: false }} />
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ══ CONTENT SECTIONS ══ */}
      <div className="content-wrap">
        <hr className="divider" id="how-to-use" />
        <div className="section-label">How it works</div>
        <h2>Four steps to your <span>deflection result</span></h2>
        <p className="section-desc">This calculator applies standard Euler–Bernoulli beam theory closed-form solutions to give you instant, accurate results for the most common beam and loading configurations in structural design.</p>

        <div className="steps">
          {[
            {
              num: "01",
              title: "Define beam geometry",
              desc: "Under the Length tab, enter the total span L of your beam. Then switch to Cross Section and input the second moment of area I for your chosen section profile — taken from section tables or the companion Section Properties Calculator."
            },
            {
              num: "02",
              title: "Set material stiffness",
              desc: "Under the Young's Modulus tab, select a material preset (structural steel, aluminium, timber, concrete) or enter a custom E value in MPa. Together with I, this defines the flexural rigidity EI that governs beam stiffness."
            },
            {
              num: "03",
              title: "Configure support and load",
              desc: "Under the Support tab, select your boundary condition — simply supported, cantilever, or fixed–fixed. Then switch to the Load tab and choose the load type: point load at midspan or free end, UDL, or applied end moment, and enter its magnitude."
            },
            {
              num: "04",
              title: "Read and verify results",
              desc: "Output metrics update live on the right panel: maximum deflection, maximum slope, both support reactions, and peak bending moment. A pass/fail badge checks your result against the L/360 serviceability limit — the standard deflection criterion for most structural applications."
            }
          ].map((step, i) => (
            <div key={i} className="step-card fade-up">
              <div className="step-num">// STEP {step.num}</div>
              <div className="step-title">{step.title}</div>
              <p className="step-desc">{step.desc}</p>
            </div>
          ))}
        </div>

        <hr className="divider" id="formulas" />
        <div className="section-label">Reference</div>
        <h2>Beam deflection <span>formula table</span></h2>
        <p className="section-desc">Standard closed-form expressions for maximum deflection based on Euler–Bernoulli beam theory. Valid for linear-elastic, prismatic members with small deflections relative to the span.</p>

        <div className="formula-table-wrap">
          <table className="formula-table">
            <thead>
              <tr>
                <th>Beam type</th>
                <th>Load configuration</th>
                <th>Max deflection δ</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Simply supported</td><td>Point load at midspan</td><td><span className="f-chip">PL³ / (48EI)</span></td><td>Midspan</td></tr>
              <tr><td>Simply supported</td><td>Uniform distributed load</td><td><span className="f-chip">5wL⁴ / (384EI)</span></td><td>Midspan</td></tr>
              <tr><td>Simply supported</td><td>Applied moment at end</td><td><span className="f-chip">ML² / (9√3·EI)</span></td><td>x = L/√3</td></tr>
              <tr><td>Cantilever</td><td>Point load at free end</td><td><span className="f-chip">PL³ / (3EI)</span></td><td>Free end</td></tr>
              <tr><td>Cantilever</td><td>Uniform distributed load</td><td><span className="f-chip">wL⁴ / (8EI)</span></td><td>Free end</td></tr>
              <tr><td>Cantilever</td><td>Moment at free end</td><td><span className="f-chip">ML² / (2EI)</span></td><td>Free end</td></tr>
              <tr><td>Fixed–fixed</td><td>Point load at midspan</td><td><span className="f-chip">PL³ / (192EI)</span></td><td>Midspan</td></tr>
              <tr><td>Fixed–fixed</td><td>Uniform distributed load</td><td><span className="f-chip">wL⁴ / (384EI)</span></td><td>Midspan</td></tr>
            </tbody>
          </table>
        </div>
        <p style={{ fontSize: '12px', color: 'var(--text3)', fontFamily: 'var(--mono)', marginTop: '-32px', marginBottom: '24px' }}>P = point load (N) · w = load per unit length (N/mm) · M = applied moment (N·mm) · L = span (mm) · E = Young's modulus (MPa) · I = second moment of area (mm⁴)</p>

        <hr className="divider" id="concepts" />
        <div className="section-label">Engineering concepts</div>
        <h2>Understanding <span>beam deflection</span></h2>
        <p className="section-desc">Key concepts that govern beam bending behaviour, deflection limits, and how to interpret and apply the results from this calculator in a structural design context.</p>

        <div className="concept-grid">
          {[
            { icon: "δ", title: "What is beam deflection?", body: "Deflection is the transverse displacement of a beam from its original unloaded position when forces or moments are applied. It is measured at the point of maximum displacement — typically midspan for simply supported beams, or at the free end for cantilevers — and expressed in mm or inches." },
            { icon: "EI", title: "Flexural rigidity EI", body: "The product EI — the flexural rigidity — governs how stiff a beam is in bending. E (Young's modulus) is a material property: steel is roughly 200,000 MPa, while timber ranges from 8,000 to 14,000 MPa. I (second moment of area) is purely geometric." },
            { icon: "L/x", title: "Serviceability limits", body: "Design codes set deflection limits to safeguard serviceability, not strength. Common limits include L/360 for floors supporting brittle finishes such as tiles or plaster, L/250 for general floor beams, and L/180 for roof purlins." },
            { icon: "Σ", title: "Superposition principle", body: "For beams carrying multiple simultaneous loads, the total deflection at any point equals the algebraic sum of the deflections produced by each load acting independently. This superposition method is valid for linear-elastic beams." },
            { icon: "×16", title: "Simply supported vs cantilever", body: "A simply supported beam with a midspan point load deflects 16 times less than a cantilever of the same span carrying an equivalent load at its free end — compare PL³/(48EI) with PL³/(3EI)." },
            { icon: "÷4", title: "Fixed-end restraint benefit", body: "Fully restraining both ends of a beam reduces midspan deflection under a central point load by a factor of 4 compared to simple supports (192EI vs 48EI denominator). This stiffness gain is accompanied by large hogging moments." }
          ].map((concept, i) => (
            <div key={i} className="concept-card">
              <div className="concept-icon">{concept.icon}</div>
              <div className="concept-title">{concept.title}</div>
              <p className="concept-body">{concept.body}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ══ FAQ — at the very end ══ */}
      <div className="content-wrap">
        <hr className="divider" id="faq" />
        <div className="section-label">FAQ</div>
        <h2>Frequently asked <span>questions</span></h2>
        <div className="faq-list">
          {[
            { q: "What units should I enter in this calculator?", a: "Enter all length dimensions in millimetres (mm): span L in mm, load P in kilonewtons (kN), distributed load w in kN/m, or applied moment in kN·m. Young's modulus E is entered in MPa (equivalent to N/mm²) and second moment of area I in mm⁴. Results are presented in mm for deflection and kN·m for bending moment. The calculator handles all internal unit conversions automatically — just ensure you are consistent." },
            { q: "What is an acceptable deflection limit for floor beams?", a: "Most structural codes (AISC 360, Eurocode 3, IS 800) limit live-load deflection of floor beams to L/360 where brittle finishes such as ceramic tiles or plaster ceilings are present, and L/250 for floors without brittle finishes. For roof members, L/180 to L/240 is typical depending on whether ponding of water is a concern. Always verify the governing limit in the applicable design code and project specification — limits can vary by load combination (dead load only, live load only, or total load)." },
            { q: "How do I find the moment of inertia I for my beam?", a: "For standard steel sections (I-beams, channels, hollow sections), look up the second moment of area in your national section tables — for example the AISC Steel Construction Manual for US shapes, or the SCI Blue Book for UK universal sections. Timber manufacturers publish engineered lumber section properties in their product guides. For custom or fabricated sections, compute I from cross-sectional dimensions using the companion Beam Section Properties Calculator. As a quick check: a simple rectangular section of width b and depth d has I = bd³/12." },
            { q: "Can I use this calculator for concrete or timber?", a: "Yes — the deflection formula is completely material-independent. Only the product EI matters. Select the concrete or timber material preset (or enter a custom E value), supply the correct I for your section, and the results are equally valid for any material. For reinforced concrete beams, use the effective (cracked) moment of inertia Ie rather than the gross section I, calculated in accordance with ACI 318-19 or Eurocode 2 to account for reduced stiffness after cracking under service loads." },
            { q: "Why does a cantilever deflect so much more than a simply supported beam?", a: "A cantilever carrying a point load at its free end deflects PL³/(3EI) at the tip, while an equivalent simply supported beam under a midspan load deflects only PL³/(48EI) — exactly 16 times less. This dramatic difference arises because a cantilever has only one support providing a moment reaction, whereas two supports sharing the load and generating restoring couples dramatically reduce the internal bending and the resulting curvature. Deflection also scales with the cube of the span length, meaning doubling the cantilever length increases tip deflection by a factor of eight." },
            { q: "How do I calculate deflection for a beam with multiple loads?", a: "Use the principle of superposition: calculate the deflection at the point of interest for each individual load acting alone on the beam, then sum all the individual deflections algebraically. This method is exact for linear-elastic beams within the small-deflection range. For example, a simply supported beam carrying both a midspan point load P and a full-span UDL w would have a total midspan deflection of PL³/(48EI) + 5wL⁴/(384EI). For more complex loading patterns with varying cross-sections, numerical methods such as the finite element method or moment-area theorems are required." },
            { q: "What is the difference between elastic and permanent (plastic) deflection?", a: "This calculator computes elastic deflection — the fully recoverable deformation that occurs within the linear-elastic range of the material. When loads are removed, the beam returns completely to its original geometry. Plastic (permanent) deflection occurs when stresses exceed the material yield point, causing irreversible deformation. Serviceability deflection checks are always performed under working (unfactored service) loads, which should be well within the elastic range, so elastic deflection formulas apply. If a beam were loaded to its plastic moment capacity, permanent set would occur and these formulas would no longer be valid." }
          ].map((faq, i) => (
            <div key={i} className={`faq-item ${activeFaq === i ? 'open' : ''}`}>
              <button className="faq-q" onClick={() => setActiveFaq(i === activeFaq ? -1 : i)}>
                <span className="faq-q-text">{faq.q}</span>
                <span className="faq-icon">{activeFaq === i ? '−' : '+'}</span>
              </button>
              <div className="faq-a">{faq.a}</div>
            </div>
          ))}
        </div>
      </div>

      <section className='cse-header-top'>
        <Link smooth="true" duration={500} offset={-70} onClick={scrollToTop} aria-label="Scroll to top">
          <GrLinkTop className='' />
        </Link>
      </section>

    </div>
  )
}
